import React, { useContext } from 'react'
import { useLocation } from 'react-router';
import { AppContext } from '../../contexts';
import Button from '../../components/button/button';
import DetailsSections from '../../components/details-sections';
import Message from '../../components/message'
import { useTranslation, useAppointmentDetails } from '../../hooks'
import './_message.scss'

const successIcon = <svg width="54" height="54" viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M8.05954 8.22125C13.3182 2.96259 19.6195 0.333252 26.9635 0.333252C34.3075 0.333252 40.5875 2.94392 45.8035 8.15992C51.0195 13.3759 53.6302 19.6559 53.6302 26.9999C53.6302 34.3439 51.0195 40.6239 45.8035 45.8399C40.5875 51.0559 34.3075 53.6666 26.9635 53.6666C19.6195 53.6666 13.3369 51.0559 8.12087 45.8399C2.90488 40.6239 0.296875 34.3439 0.296875 26.9999C0.296875 19.6559 2.88621 13.3946 8.05954 8.22125ZM21.5875 43.0426L45.5875 19.0426L41.8382 15.1653L21.5875 35.4159L12.0889 25.9173L8.33687 29.6666L21.5875 43.0426Z" fill="#14B83D"/> </svg>;
const errorIcon = <svg width="54" height="54" viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg"> <path fillRule="evenodd" clipRule="evenodd" d="M26.9997 0.333313C12.2743 0.333313 0.333008 12.272 0.333008 27C0.333008 41.728 12.2743 53.6666 26.9997 53.6666C41.725 53.6666 53.6663 41.728 53.6663 27C53.6663 12.272 41.725 0.333313 26.9997 0.333313ZM29.6663 32.3333V11H24.333V32.3333H29.6663ZM29.6663 37.6666V43H24.333V37.6666H29.6663Z" fill="#D14234"/> </svg>;
const mailSentIcon = <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M42.5334 58.666L31.2 47.3327L34.9334 43.5993L42.5334 51.1993L57.6 36.1327L61.3334 39.866L42.5334 58.666ZM10.6667 53.3327C9.20004 53.3327 7.94449 52.8105 6.90004 51.766C5.8556 50.7216 5.33337 49.466 5.33337 47.9994V15.9993C5.33337 14.5327 5.8556 13.2771 6.90004 12.2327C7.94449 11.1882 9.20004 10.666 10.6667 10.666H53.3334C54.8 10.666 56.0556 11.1882 57.1 12.2327C58.1445 13.2771 58.6667 14.5327 58.6667 15.9993V27.5993L42.6 43.666L34.9334 35.9993L23.6667 47.266L29.7334 53.3327H10.6667ZM32 34.666L53.3334 21.3327V15.9993L32 29.3327L10.6667 15.9993V21.3327L32 34.666Z" fill="#0C59B2"/>
<path d="M42.534 58.6661L31.2007 47.3328L34.934 43.5995L42.534 51.1995L57.6007 36.1328L61.334 39.8661L42.534 58.6661Z" fill="#21D127"/>
</svg>


function MessageView() {
  const { i18n } = useTranslation();
  const { state } = useLocation();
  const { appointmentData: { confirmationNumber }, appointmentDataLoading, appointmentTime, newLinkLoading } = useContext(AppContext);
  const details = useAppointmentDetails(appointmentTime.startTimeInUTC, appointmentTime.endTimeInUTC);

  const {
    title = i18n('cp_error_title'),
    copy = i18n('cp_error_copy'),
    status = false,
    cta,
    onCtaClick,
    newlink,
    callBackFunc,
    icon
  } = state || {};

  const decideLogo = () => {
     return icon === 'successMail' ? mailSentIcon : (status ? successIcon : errorIcon);
  }

  return (
    <div className="message-view container">
      <Message title={title} copy={copy} status={status} icon={decideLogo()} />
      {status && confirmationNumber && icon !== 'successMail' && <div className="card message-view__card">
        <DetailsSections title={i18n('cp_appointment_details')} items={details} />
      </div>}
      {cta && onCtaClick && <Button loading={appointmentDataLoading} testId="cta" onClick={onCtaClick} className="message-view__cta">{cta}</Button>}
      {newlink && callBackFunc && <Button loading={newLinkLoading} className="message-view__cta default-background" onClick={callBackFunc} >{i18n('cp_request_access_btn')}</Button>  }
    </div>
  )
}

export default MessageView
